import * as React from 'react'

function SvgIconCut(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="cut" aria-labelledby="t-cut d-cut">
        <title id="t-cut">{'Cut'}</title>
        <desc id="d-cut">{'Scissors'}</desc>
        <path d="M10.769 23.09c-.644-.652-1.479-1.02-2.384-1.111L30 .006s-5.562.001-10.33 4.847L8.686 16.017a1.016 1.016 0 00-.238 1.024l.503 1.534-5.137 5.221c-2.113 2.147-2.423 5.312-.695 7.067 1.729 1.758 4.841 1.441 6.954-.707 2.113-2.145 2.424-5.31.696-7.066zM9.38 16.725L20.366 5.56A15.491 15.491 0 0127.14 1.5L10.076 18.846l-.696-2.121zM4.51 29.45c-.943-.958-.624-2.899.695-4.241 1.32-1.341 3.23-1.664 4.172-.706.943.958.625 2.899-.695 4.241-1.32 1.341-3.23 1.663-4.172.706zM8.702 13.173l1.391-1.414-1.709-1.738c.905-.092 1.74-.457 2.384-1.11 1.729-1.757 1.417-4.921-.696-7.068C7.958-.305 4.847-.622 3.117 1.136 1.389 2.892 1.7 6.057 3.812 8.204l4.89 4.969zM4.508 2.549c.942-.958 2.853-.634 4.172.707 1.32 1.341 1.638 3.284.696 4.241-.943.959-2.853.635-4.172-.706-1.32-1.342-1.639-3.284-.696-4.242z" />
        <path d="M14.96 18.122l12.181 12.377a15.44 15.44 0 01-6.771-4.058l-6.794-6.906-.696.707 6.794 6.906C24.438 31.993 30 31.993 30 31.993L15.656 17.415l-.696.707z" />
      </g>
    </svg>
  )
}

export default SvgIconCut
